import PhoenixScottsdale, { getServerSideProps } from './Phoenix';
export default PhoenixScottsdale;
export { getServerSideProps };
